/** Key for the single Planner Default Plan ID cache record. */ export const PlannerDefaultPlanIdKey = "plannerDefaultPlan";
